import Monthly, {
  getServerSideProps as hgetServerSideProps,
} from '@pages/myapp/events/[friendlyUrl]';
import { GetServerSideProps } from 'next';

export const getServerSideProps: GetServerSideProps = hgetServerSideProps;

export default Monthly;
